var _defs, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSpinnerCover1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85.7,
    height: 369.2,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    y2: 0.982857,
    y1: 0.017143,
    id: "gradient0",
    spreadMethod: "pad",
    x2: 0.629286,
    x1: 0.370714
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.721569
  })), /*#__PURE__*/React.createElement("linearGradient", {
    y2: -0.253571,
    y1: 1.253571,
    id: "gradient1",
    spreadMethod: "pad",
    x2: 0.297857,
    x1: 0.702143
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "gradient2",
    gradientTransform: "matrix(0.0275726318359375 0 0 0.0275726318359375 75.45 211.9)",
    spreadMethod: "pad",
    cy: 0,
    cx: 0,
    r: 819.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "background"), /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    id: "canvas_background",
    height: 371.2,
    width: 87.7,
    y: -1,
    x: -1
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("g", {
    id: "svg_1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "svg_2",
    d: "m51.599998,14.299999q0,3.600002 -2.599998,6.150002q-2.550003,2.599998 -6.150002,2.599998q-3.599998,0 -6.199997,-2.599998q-2.550003,-2.549999 -2.550003,-6.150002q0,-3.599998 2.550003,-6.199999q2.599998,-2.550001 6.199997,-2.550001q3.599998,0 6.150002,2.550001q2.599998,2.6 2.599998,6.199999",
    fill: "url(#gradient0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_3",
    d: "m51.599998,14.299999q0,3.600002 -2.599998,6.150002q-2.550003,2.599998 -6.150002,2.599998q-3.599998,0 -6.199997,-2.599998q-2.550003,-2.549999 -2.550003,-6.150002q0,-3.599998 2.550003,-6.199999q2.599998,-2.550001 6.199997,-2.550001q3.599998,0 6.150002,2.550001q2.599998,2.6 2.599998,6.199999",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 2,
    stroke: "url(#gradient1)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_4",
    d: "m81.199997,194.399994q0,15.900009 -11.25,27.100006q-11.199997,11.25 -27.099998,11.25q-15.9,0 -27.15,-11.25q-11.199997,-11.199997 -11.199997,-27.100006q0,-15.899994 11.199997,-27.149994q11.25,-11.199997 27.15,-11.199997q15.900002,0 27.099998,11.199997q11.25,11.25 11.25,27.149994m-27.25,10.200012q4.650002,-4.650009 4.650002,-11.25q0,-6.600006 -4.650002,-11.25q-4.650002,-4.650009 -11.25,-4.650009q-6.599998,0 -11.249998,4.650009q-4.649998,4.649994 -4.649998,11.25q0,6.599991 4.649998,11.25q4.65,4.649994 11.249998,4.649994q6.599998,0 11.25,-4.649994",
    fillOpacity: 0.2,
    fill: "#3399ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_5",
    d: "m53.949997,204.600006q-4.650002,4.649994 -11.25,4.649994q-6.599998,0 -11.249998,-4.649994q-4.649998,-4.650009 -4.649998,-11.25q0,-6.600006 4.649998,-11.25q4.65,-4.650009 11.249998,-4.650009q6.599998,0 11.25,4.650009q4.650002,4.649994 4.650002,11.25q0,6.599991 -4.650002,11.25",
    fill: "url(#gradient2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_6",
    d: "m53.949997,204.600006q-4.650002,4.649994 -11.25,4.649994q-6.599998,0 -11.249998,-4.649994q-4.649998,-4.650009 -4.649998,-11.25q0,-6.600006 4.649998,-11.25q4.65,-4.650009 11.249998,-4.650009q6.599998,0 11.25,4.650009q4.650002,4.649994 4.650002,11.25q0,6.599991 -4.650002,11.25",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 0.05,
    stroke: "#666666",
    fill: "none"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinnerCover1);
export default __webpack_public_path__ + "static/media/spinner_cover1.564e25f11905983eb5ea59dc69af3e62.svg";
export { ForwardRef as ReactComponent };